import React from "react";
import { Spinner as NSpinner, ISpinnerProps } from "native-base";

export const Spinner: React.FC<ISpinnerProps> = (props) => {
  return <NSpinner {...props} />;
};

export default Spinner;
